import { Flex, Group, Stack, Text } from '@mantine/core';

import { CourseValidationAction } from '@/module/Author/Course/Validation/CourseValidationAction';
import { CourseValidationHistory } from '@/module/Author/Course/Validation/CourseValidationHistory';
import { CourseDeleteButton } from '@/module/Author/Course/components/CourseDeleteButton';

import { Content, EditButtonLink } from '@/core/components';

import { AuthorList } from '@feature/utils';

import { CourseProofAction } from './Proof';
import { Course } from './model/CourseTypes';

interface CourseViewProps {
  course: Course;
}

export function CourseView(props: CourseViewProps) {
  const { course } = props;
  const { title, publisher, noOfPages, authors, year } = course;

  return (
    <Stack>
      <Content type="full">
        <Stack gap="4px">
          <Flex justify="space-between">
            <Text fw="500">{`${title} (${year})`}</Text>
            <Group>
              <EditButtonLink
                size="xs"
                miw="100px"
              />
              <CourseDeleteButton courseId={course.id} />
            </Group>
          </Flex>
          <Text size="sm">Publicat la: {publisher?.title ?? '-'}</Text>
          <Text
            c="dimmed"
            size="xs"
          >
            {noOfPages} pagini
          </Text>
        </Stack>
      </Content>
      <Content type="full">
        <AuthorList authors={authors} />
      </Content>
      <CourseProofAction
        courseId={course.id}
        authors={authors}
      />
      <CourseValidationAction courseId={course.id} />
      <CourseValidationHistory courseId={course.id} />
    </Stack>
  );
}
